export enum SettingsActionList {
  PROFILE_SETTINGS = '[Settings] profile',
  PROFILE_SETTINGS_SUCCESS = '[Settings] profile success',
  PROFILE_SETTINGS_FAIL = '[Settings] profile fail',

  RESET = '[Settings] reset',
}
